<template>
  <div class="boss-user-info">
    <div class="boss-user-info-left">
      <div
        class="boss-send-target"
        data-test="target-count"
      >
        送信対象（{{ checkedMemberCount }}名）
      </div>
      <div class="vertical boss-send-target-info">
        <div
          v-for="(member, index) in renderingMembers"
          :key="index"
          :class="{ 'is-active': currentUserIndex == index }"
          class="boss-send-target-item"
        >
          <span
            v-show="canShowUser(member.checked)"
            :data-test="'user-info-' + index"
            class="boss-user-data"
            @click="selectUser(index)"
          >
            <input
              v-if="isEdit"
              :checked="member.checked"
              :value="member.id"
              type="checkbox"
              class="boss-input-checkbox margin-auto"
              :data-test="'user-check-' + index"
              @change="onUserChecked(!member.checked, index)"
            >
            <div
              class="boss-user-data-left"
            >
              <span
                data-test="img-click"
                @click="isEdit ? onUserChecked(!member.checked, index) : ''"
              >
                <img
                  v-if="isNew(member)"
                  :alt="'ID:' + member.id"
                  data-test="boss-avatar-new"
                  class="boss-user-data-image pega-margin-x-3"
                  src="../../assets/images/boss-avatar-new.svg"
                >
                <img
                  v-else
                  :alt="'ID:' + member.id"
                  data-test="boss-avatar"
                  class="boss-user-data-image pega-margin-x-3"
                  src="../../assets/images/boss-avatar.svg"
                >
              </span>
              <div class="boss-user-data-id">
                <span>ID:{{ member.id }}</span>
                <div
                  v-if="!member.checked"
                  class="boss-annotation-text font-size-1-3em"
                >
                  送信対象外
                </div>
              </div>
            </div>
            <div
              class="boss-user-data-right display-block"
              data-test="member-summary"
            >
              {{ getNameOrUndefined(member, 'presentAddressPrefecture.name') |parseBlankForDefaultValue('現住所') }} {{ member.birthdate | parseAge | parseBlankForDefaultValue('年齢', '歳') }} {{ getNameOrUndefined(member, 'gender.name') | parseBlankForDefaultValue('性別') }} /{{ member.employed | convertEmployedLabel | parseBlankForDefaultValue('就業状況') }}/{{ getNameOrUndefined(member,'careerResumes[0].annualSalary') | parseNumberValue('年収', '万円') }}/{{ member.changeOverJobsCount | parseNumberValue('転職回数', '回') }}</div>
          </span>
        </div>
        <infinite-loading
          ref="infiniteLoading"
          @infinite="infiniteHandler"
        >
          <div slot="no-more" />
          <div slot="no-results" />
          <div slot="spinner" />
        </infinite-loading>
      </div>
    </div>
    <div class="boss-user-info-right">
      <div class="boss-user-resume">
        会員レジュメ
      </div>
      <div class="boss-tabs-content-resume">
        <div
          v-for="(member, index) in renderingMembers"
          :key="index"
          :class="{ 'is-active': currentUserIndex == index }"
          class="boss-tabs-content-wrap"
        >
          <!-- ▼職務経歴書 -->
          <scout-member-career-resume
            :member="member"
          />
          <!-- ▲職務経歴書 -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import * as definition from '@/lib/labelValueMappings'
import ScoutMemberCareerResume from '@/components/molecules/ScoutMemberCareerResume'
import { now, createDate } from '@/lib/dateUtils.js'
import * as parse from '@/lib/parse'
import InfiniteLoading from 'vue-infinite-loading'
import InfinityScrollIterator from '@/lib/infinityScrollIterator'

export default {
  components: { ScoutMemberCareerResume, InfiniteLoading },
  filters: {
    parseBlankForDefaultValue (label, unregisteredValue, suffix = '') {
      return label ? label + suffix : unregisteredValue + '未登録'
    },
    parseNumberValue (value, unregisteredValue, suffix = '') {
      return parse.numberValue(value, suffix, unregisteredValue)
    },
    parseAge (birthdateString) {
      return parse.age(birthdateString)
    },
    convertEmployedLabel (value) {
      return _.isBoolean(value) ? definition.employed.find(employed => employed.value === value).name : ''
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      required: true
    },
    members: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      currentUserIndex: 0,
      renderingMembers: []
    }
  },
  computed: {
    checkedMemberCount () {
      return _(this.members).filter('checked').value().length
    }
  },
  watch: {
    members (val) {
      if (_.has(this.$refs, 'infiniteLoading.stateChanger')) {
        this.$refs.infiniteLoading.stateChanger.reset()
      }
      this.$set(this, 'renderingMembers', [])
      this.infinityScrollIterator = new InfinityScrollIterator(val, 20)
    }
  },
  methods: {
    selectUser (index) {
      this.$set(this, 'currentUserIndex', index)
    },
    getNameOrUndefined (val, path) {
      return _.get(val, path)
    },
    isNew (member) {
      return now().subtract(10, 'days').isSameOrBefore(createDate(member.recentActionDate, 'YYYY-MM-DDTHH:mm:ss'), 'day')
    },
    onUserChecked (checked, index) {
      this.$emit('setUserChecked', checked, index)
    },
    canShowUser (checked) {
      return this.isEdit || checked
    },
    infiniteHandler ($state) {
      if (this.infinityScrollIterator) {
        const next = this.infinityScrollIterator.next()
        if (next.done) {
          $state.complete()
        } else {
          this.renderingMembers.push(...next.value)
          $state.loaded()
        }
      }
    }
  }
}
</script>
